import { render, staticRenderFns } from "./ChooseLogistics.vue?vue&type=template&id=8cb113ea&scoped=true&"
import script from "./ChooseLogistics.vue?vue&type=script&lang=js&"
export * from "./ChooseLogistics.vue?vue&type=script&lang=js&"
import style0 from "./ChooseLogistics.vue?vue&type=style&index=0&id=8cb113ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb113ea",
  null
  
)

export default component.exports